/**
 * @file ScrollView atom — scroll container primitive.
 * @description Temporary thin re-export of the Gluestack ScrollView so app
 * code (e.g. the /playground gallery) never imports react-native's
 * ScrollView directly. Will grow a narrowed prop surface like the other
 * atoms when the scroll API is ratified.
 * @module components/atoms/ScrollView
 */
export { ScrollView } from "@/components/ui/scroll-view";
